
import React, { useEffect, useState, useImperativeHandle } from 'react'

import { Combination, CombinationPopup } from './style'
import bridge from '@/config/JSbridge'

import { Modal, Toast } from 'antd-mobile'

import {fetchCombineCombines, fetchCombineRegister, fetchCombineStatus } from '@/api/combine'


export default React.forwardRef( ({token, user, getRank}, ref) => {
  const [visible, setvisible] = useState(false);
  const [list, setlist] = useState([]);
  const [combineInfo, setCombineInfo] = useState({});

  const [status, setSatus] = useState(0);

  const [activeId, setActiveId] = useState(''); // combineId
  
  useImperativeHandle(ref, () => {
    return {
      refresh: () => {
        console.log('combine');
        if(visible) {
          getList();
        }
      }
    }
  })

  const initStatus = () => {
   
    if(!token) { return }

    const params = {}
    fetchCombineStatus(params)
    .then(res => { 
        setSatus(res.data.status);

        setCombineInfo(res.data);

    })
  }
 
  useEffect(()=> {
    initStatus()
    
  },[token])
  const onClose = (e) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    setvisible(false);
    setActiveId('')
  }

  const showModal =  (e) => {
    e.preventDefault(); // 修复 Android 上点击穿透
    if(!token) {
      return handleLogin()
    }
  
    setvisible(true);
    setActiveId('')
  }

  const handleLogin = () => {
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
  }

  const toCombination =  (e) => {
    window.location = 'storm://app/combination/create';
  }

  useEffect(()=> {
    if(visible) {
      getList()
    }
  },[visible])

  const handleCombineRegister = () => {
  
    if(!list.length) {
      return  Toast.info('您目前还没有组合，请创建参赛组合！')
    }
  
    const params = {
      combineId: activeId
    }
    fetchCombineRegister(params)
      .then(res => {
        initStatus() // 
        setvisible(false);
        getRank()
      })
      .catch(err => {
        Toast.info(err.response.data.desc)

        // console.log(err[0].message);
      })
  }

  




  function getList() {
    const params = {}
    fetchCombineCombines(params)
      .then(res => {
        const items = res.data.items;
        
        setlist(items);
        if(items &&  items.length>0) {
          setActiveId(items[0].combineId)
        }
      
      })
  }

  function  toCombinationList () {
    const userId= user.userId;
    window.location = 'storm://app/user/combinationList?userId='+userId
  
  }  // storm://app/user/combinationList
  
  // function toDealDetails() {
  //   window.location = `storm://app/combine/marketSectionDetail?stockCode=${combineInfo.combineId}`
  // }

  return (
    <div >
      {status === 1 ? (
        <Combination >
          <div className="title" >
            <div>我的参赛组合：</div>
            <div style={{color: '#070B0D'}}>{combineInfo.combineName}</div>
          </div>

          <div className='container'>
            <div className='left'>
              <div className="title" >
                <span>参赛收益</span>
              </div>

              <div className="li" >
                <span>周收益: </span>
                <span style={{color: '#070B0D', fontWeight: 'normal'}}> { combineInfo.weekRank !== 0 && combineInfo.weekChangePCT>0 && '+'}  { combineInfo.weekRank === 0? '-': ((combineInfo.weekChangePCT || combineInfo.weekChangePCT === 0) ? Number(combineInfo.weekChangePCT ).toFixed(2) + '%' : '0.00%')}</span>
              </div>
              <div className="li" >
                <span>排名: </span>
                <span style={{color: '#070B0D', fontWeight: 'normal'}}>{ combineInfo.weekRank === 0? '-' : (combineInfo.weekRank > 200? "200+": combineInfo.weekRank )}</span>
              </div>
              <div className="li" >
                <span>季收益: </span>
                <span style={{color: '#070B0D', fontWeight: 'normal'}}> { combineInfo.quarterRank !== 0 && combineInfo.quarterChangePCT>0 && '+'}  { combineInfo.quarterRank === 0? '-': ((combineInfo.quarterChangePCT || combineInfo.quarterChangePCT === 0)? Number(combineInfo.quarterChangePCT ).toFixed(2) + '%' : '0.00%')}</span>
             
                {/* <span> {combineInfo.quarterChangePCT>0 && '+'}  {combineInfo.quarterChangePCT ? Number(combineInfo.quarterChangePCT ).toFixed(2) + '%' : '0%'}</span> */}
              </div>
              <div className="li" >
                <span>季排名: </span>
                
                <span style={{color: '#070B0D', fontWeight: 'normal'}}>{ combineInfo.quarterRank === 0? '-' : (combineInfo.quarterRank > 200? "200+": combineInfo.quarterRank )}</span>
              </div>
            </div>
          <div className='btn' onClick={()=>{
            // toDealDetails()
            toCombinationList()
          }}></div>
          

          </div>
        </Combination>
      ):(
        <Combination className='empty'>
          <div className="title" >
            您还未报名参赛
          </div>
          <div className='btn2' onClick={(e) => showModal(e)}></div>
        </Combination>
      )}
    

      <Modal
          popup
          visible={ visible }
          onClose={(e)=>onClose(e)}
          animationType="slide-up"
        >
         
          <CombinationPopup>
 
          <div className='modalTitle'>请选择您要参赛的组合</div>
          <div className='closeImg' onClick={onClose}></div>
          {
        list.length>0 ? (
          <div className='content'>
            {
              list.map(it => {
                return (
                  <div className='li' key={it.combineId} onClick={()=> setActiveId(it.combineId)}>
                   {
                    it.combineId === activeId ? (
                      <img className='state' src={require('@/img/activity50/state2@2x.png')} alt="市值风云" />
                    ): (
                      <img className='state' src={require('@/img/activity50/state@2x.png')} alt="市值风云" />
                    )
                   }  
                    {it.combineName}
                  </div>
                )
              })
            }
            {
              list.length<10 && <div className='empty li' onClick={()=>toCombination()}><img className='state'  src={require('@/img/activity50/state3@2x.png')} alt="市值风云" />新建组合参赛</div>
       
            }
         </div>
        ):(
          <div className='emptyList'>
            <div>您暂未创建相关组合，无法进行报名参赛！</div>
            <div className='empty' onClick={()=>toCombination()}><img className='state'  src={require('@/img/activity50/state3@2x.png')} alt="市值风云" />新建组合参赛</div>
          </div>
        )
      }
         
      
         <div className={list.length>0? 'competition' :'competition disabled'}  onClick={()=>{handleCombineRegister()}}>确认参赛</div>
        
        {
          list.length>0 &&  <div className='toCombination' onClick={()=>toCombinationList()}>
              查看全部组合
            <img src={require('@/img/activity50/to2@2x.png')} alt='' />
          </div>
        } 
          <div className='tips'>
            <div>注：1）参赛收益即所选参赛组合活动周期期间涨幅；
              </div>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2）参赛组合一旦确认，则无法更改；</div>
          </div>
          </CombinationPopup>
        </Modal>
    </div>
  )
}
)


// WEBPACK FOOTER //
// ./src/views/activity_100/components/combination.js